import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../core/http/authentication.service';
import { Logger } from '../../core/services/logger.service';

@Component({
  standalone: true,
  templateUrl: './pw-changed.component.html',
  styleUrls: ['./pw-changed.component.scss'],
})
export class PwChangedComponent implements OnInit {
  private readonly _authService = inject(AuthenticationService);
  private readonly _router = inject(Router);
  private readonly _logger = inject(Logger);

  async ngOnInit(): Promise<void> {
    try {
      await this._authService.logout();
    } catch (error: unknown) {
      this._logger.log('Logout after password change failed', error);
    } finally {
      this._authService.removeSessionData();
    }
  }

  toLogin(): void {
    void this._router.navigate(['/login']);
  }
}
